<template>
  <div>
    <ShopSteps :step="3"/>
    <section class="py-4 gry-bg">
      <div class="container">
        <div class="row">
          <div class="col-xxl-8 col-xl-10 mx-auto">
            <div
                v-for="(shop, index) in userCart"
                :key="index"
                class="card mb-3 shadow-sm border-0 rounded"
            >
              <div class="card-header p-3">
                <h5 class="fs-16 fw-600 mb-0">
                  {{ shop.name }} {{ $t("产品") }}
                </h5>
              </div>
              <div class="card-body">
                <ul class="list-group list-group-flush">
                  <li
                      v-for="(goods, index2) in shop.carts"
                      :key="index2"
                      class="list-group-item"
                  >
                    <div class="d-flex">
                      <span class="mr-2">
                        <img
                            :src="
                            getFileViewUrl(goods.goodsSpecPic || goods.goodsPic)
                          "
                            alt
                            class="img-fit size-60px rounded"
                        />
                      </span>
                      <div class="ml-2">
                        <div class="fs-14 opacity-60">{{ goods.goodsName }}</div>
                        <div class="fs-14 text-secondary" v-if="isValidateSpec(goods.goodsSpecName)">
                          {{ goods.goodsSpecName }}
                        </div>
                        <div class="fs-14 text-primary">{{ formatMoney(priceDiscount(shop, goods)) }} x {{ goods.number }}</div>
                      </div>
                    </div>
                  </li>
                </ul>

                <div class="row border-top pt-3">
                  <div class="col-md-6">
                    <h6 class="fs-15 fw-600">
                      {{ $t("选择交货类型") }}
                    </h6>
                  </div>
                  <div class="col-md-6">
                    <div class="row gutters-5">
                      <div class="col-6">
                        <label class="aiz-megabox d-block bg-white mb-0">
                          <input
                              checked=""
                              type="radio"
                              value="home_delivery"
                          />
                          <span class="d-flex p-3 aiz-megabox-elem">
                            <span
                                class="aiz-rounded-check flex-shrink-0 mt-1"
                            ></span>
                            <span class="flex-grow-1 pl-3 fw-600">{{
                                $t("送货上门")
                              }}</span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pt-4 d-flex justify-content-between align-items-center">
              <router-link to="/">
                <i class="la la-angle-left"></i>
                {{ $t("返回商店") }}
              </router-link>
              <button
                  class="btn fw-600 btn-primary"
                  type="submit"
                  @click="onClickContinue"
              >
                {{ $t("继续付款") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {getCartList} from "@/api/user.cart";
import ShopSteps from "@/components/ShopSteps.vue";

export default {
  components: {ShopSteps},
  created() {
    if (!this.userCartItemCount) {
      this.jump("/user/cart");
    }
  },
  methods: {
    onClickContinue() {
      this.jump(
          "/user/checkout/payment_select?needAddress=1"
          // "/user/checkout/payment_select?addressId=" + this.$route.query.addressId
      );
    },
    priceDiscount(shop, goods) {
      if (!shop.isSeckillShop) return goods.price
      let buyDiscount = goods && goods.buyDiscount || 100;
      return goods && goods.price * buyDiscount / 100
    }
  },
};
</script>
